import { render, staticRenderFns } from "./storeCoupons.vue?vue&type=template&id=19f55cf0&"
import script from "./storeCoupons.vue?vue&type=script&lang=js&"
export * from "./storeCoupons.vue?vue&type=script&lang=js&"
import style0 from "./storeCoupons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports